// extracted by mini-css-extract-plugin
module.exports = {"UndoToast__undo":"py_a pz_st pz_gs"};